export enum ThemeId {
  Deluge = 'Deluge::ThemeId',
  DelugeLight = 'DelugeLight::ThemeId',
  Test = 'Test::ThemeId',
  Photgone = 'Photgone::ThemeId',
  Monokai = 'Monokai::ThemeId',
}
